<template>
  <div class="transfer">
    <p class="description">
      Please select the target type you want to transfer
    </p>

    <div class="transfer-way">
      <div @click="transferHandle">
        <img :src="require('@/assets/ToBank.png')">
        <p>{{ $t('toBankAccount') }}</p>
      </div>

      <div @click="handleTransferToAccount">
        <img :src="require('@/assets/ToFlashpay.png')">
        <p>{{ $t('toFlashPayAccount') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { InputItem, Field, NumberKeyboard, Icon, Button } from 'mand-mobile'
import { mapMutations } from 'vuex'

export default {
  name: 'TransferToAccount',

  components: {
    [InputItem.name]: InputItem,
    [NumberKeyboard.name]: NumberKeyboard,
    [Field.name]: Field,
    [Icon.name]: Icon,
    [Button.name]: Button
  },

  mounted () {
    this.$nextTick(() => {
      this.change_addClass(true)
    })
  },
  methods: {
    ...mapMutations(['change_addClass']), // 控制header头部的颜色
    handleTransferToAccount () {
      this.$router.push({ name: 'TransferToAccountInputUser' })
    },
    transferHandle () {
      this.$router.push({ name: 'TransferToBank' })
    }
  }
}
</script>

<style lang="scss" scoped>
.transfer {
  height: 100%;

  .description {
    margin: 40px auto;
    text-align: center;
  }
}

.transfer-way {
  background: #fff;
  padding: 0 40px;

  & > div {
    display: flex;
    align-items: center;
    flex: 1;
    margin-top: 56px;
    height: 200px;
    border-radius: 32px;
    box-shadow: 0 8px 32px 0 rgba(138, 149, 158, 0.2);

    img {
      width: 80px;
      height: 80px;
      background: #f0f0f0;
      border-radius: 50%;
      margin-left: 64px;
    }

    p {
      margin-top: 14px;
      margin-left: 64px;
      color: #333;
      font-size: 32px;
      font-weight: 500;
    }
  }
}
</style>
